import { AxiosClient } from "./AxiosClient";

export const createShare = (
  content_type,
  document_id,
  target_type,
  target_team_id,
  message = "",
  target = "",
) => {
  try {
    return AxiosClient.post("share/create", {
      content_type,
      document_id,
      target_type,
      target_team_id,
      message,
      target,
    });
  } catch (e) {
    console.log(e);
  }
};

export const acceptShare = (invite_id, content_type, document_id) => {
  try {
    return AxiosClient.post("share/accept", {
      invite_id,
      content_type,
      document_id,
    });
  } catch (e) {
    console.log(e);
  }
};

export const declineShare = (invite_id, content_type, document_id) => {
  try {
    return AxiosClient.post("share/decline", {
      invite_id,
      content_type,
      document_id,
    });
  } catch (e) {
    console.log(e);
  }
};

export const revokeShare = (content_type, document_id, target_uuid) => {
  try {
    return AxiosClient.post("share/revoke", {
      content_type,
      document_id,
      target_uuid,
    });
  } catch (e) {
    console.log(e);
  }
};

export const removeShare = (content_type, document_id, owner_uuid) => {
  try {
    return AxiosClient.post("share/remove", {
      content_type,
      document_id,
      owner_uuid,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getSharedWithMe = () => {
  try {
    return AxiosClient.get("share/getSharedWithMe");
  } catch (e) {
    console.log(e);
  }
};

export const getShareInfo = (content_type, document_id) => {
  try {
    return AxiosClient.get(
      "share/getShareInfo?content_type=" +
        encodeURIComponent(content_type) +
        "&document_id=" +
        encodeURIComponent(document_id),
    );
  } catch (e) {
    console.log(e);
  }
};

export const shareArticle = (
  documentId,
  targetType,
  targetTeamId,
  message,
  articleSnapshot,
) => {
  try {
    return AxiosClient.post("share/article", {
      document_id: documentId,
      target_type: targetType,
      target_team_id: targetTeamId,
      message: message || "",
      article_snapshot: articleSnapshot || {},
    });
  } catch (e) {
    console.log(e);
  }
};
